import Breadcrumb from "../Component/Breadcrumb";
const CbseInfo = () => {
  return (
    <>
      <Breadcrumb
        breadtitle="CBSE Information Link"
        breadmid="About"
        breadend="CBSE Information Link"
      />
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="maintitle mb-4">
                CBSE Information Link -{" "}
                <span>
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/cbseinfo.pdf"
                    target="_blank"
                  >
                    <i class="bi bi-download"></i>
                  </a>
                </span>
              </h2>
              <iframe
                className="cbseLink mb-4"
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/cbseinfo.pdf"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CbseInfo;
